import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["item"];
import React from 'react';
import { formatDate } from '../../utils';
import { Row } from './Row';
import i18n from './i18n';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export function HelpRow(_ref) {
  var item = _ref.item,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var description = /*#__PURE__*/_jsxs(_Fragment, {
    children: [item.sla_days ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [i18n('context_sla-days', {
        count: item.sla_days
      }), "\xA0"]
    }) : null, item.sla_end_date ? /*#__PURE__*/_jsxs(_Fragment, {
      children: ["(", i18n('context_sla-end-to'), "\xA0", /*#__PURE__*/_jsxs("time", {
        children: [formatDate(item.sla_end_date, {
          month: 'long',
          day: 'numeric'
        }), ")"]
      })]
    }) : null]
  });
  return /*#__PURE__*/_jsx(Row, _objectSpread({
    description: description,
    item: item
  }, otherProps));
}
// #sourceMappingURL=HelpRow.js.map